<template>
    <div class="container mb-2" id="steps">
        <button data-v-5e23f409="" type="submit" dusk="submit" class="btn btn-outline-primary" onclick="window.history.back()">{{$t('vue.checkout.checkoutLoginRegister.back')}}</button>

      <div class="checkout-step-indicator">

            <div class="d-none d-md-block pt-2 pb-1">
                <span :class="activeStep(1) ? 'current' : previousStep(1) ? 'previous' : ''">
                    <span>{{$t('vue.checkout.steps.personals')}}</span>
                    <span><i class="fal fa-arrow-right px-1"></i>&nbsp;</span>
                </span>

                <span :class="activeStep(2) ? 'current' : previousStep(2) ? 'previous' : ''">
                    <span>{{$t('vue.checkout.steps.handingOver')}}</span>
                    <span><i class="fal fa-arrow-right px-1"></i>&nbsp;</span>
                </span>

                <span :class="activeStep(3) ? 'current' : previousStep(3) ? 'previous' : ''">
                    <span>{{$t('vue.checkout.steps.overview')}}</span>
                </span>
            </div>

            <div class="d-block d-md-none steps-mobile" id="steps-mobile">
                <div class="row justify-content-center py-1">
                        <span :class="activeStep(1) ? 'current' : previousStep(1) ? 'previous' : ''">
                            <span>{{$t('vue.checkout.steps.personals')}}</span>
                            <span><i class="fal fa-arrow-right"></i>&nbsp;</span>
                        </span>
                        <span :class="activeStep(2) ? 'current' : previousStep(2) ? 'previous' : ''">
                            <span>{{$t('vue.checkout.steps.handingOver')}}</span>
                            <span><i class="fal fa-arrow-right"></i>&nbsp;</span>
                        </span>
                        <span :class="activeStep(3) ? 'current' : previousStep(3) ? 'previous' : ''">
                            <span>{{$t('vue.checkout.steps.overview')}}</span>
                        </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Steps-3",
        props: {
            current: Number
        },
        data() {
            return {};
        },
        methods: {
            activeStep(step) {
                return this.current === step;
            },
            previousStep(step) {
                return this.current >= step;
            }
        }
    }
</script>

<style scoped>
    #steps {
        padding-left: 0;
        padding-right: 0;
    }

    #steps-mobile {
        font-size: 0.7rem;
        font-weight: 700;
    }

    a {
        color: #00AF41 !important;
    }
    .checkout-step-indicator {
        margin-top: 0;
    }

</style>
